import { Typography, Link, List, ListItem, ListItemText, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LegalPage from '../../components/common/LegalPage';
import { PATHS } from '../../routes';

const StateHeading = ({ children }) => (
  <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>
    {children}
  </Typography>
);

export default function Licensing() {
  return (
    <LegalPage title="Cherry Creek Mortgage, LLC Legal Disclosures and License Information">
      <Typography variant="body1">
        It is the policy of Cherry Creek Mortgage, LLC (CCM) to comply with the Equal Credit Opportunity Act and
        the Fair Housing Act. In addition, it is CCM policy to comply with state laws that provide greater
        protection. CCM is an Equal Housing Lender, and does not engage in business practices that discriminate
        against any applicant on the basis of race; color; religion; creed; national origin; ancestry; sex; marital
        status; familial status (number and age of children); sexual orientation; age (provided that the applicant
        has the capacity to enter into a binding agreement); medical history; disability; physical condition;
        military status; because the applicant has in good faith exercised any right under the Consumer Credit
        Protection Act or Servicemembers Civil Relief Act (SCRA); that all or part of a consumer&rsquo;s income
        derives from a public assistance program; or any other basis prohibited by law. The federal agency that
        administers our compliance with these federal laws is the Federal Trade Commission, Equal Credit
        Opportunity, Washington, DC, 20580.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 1, fontWeight: 700 }}>State Disclosure Requirements</Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Cherry Creek Mortgage, LLC is a licensed mortgage lender in the following states:
      </Typography>

      <StateHeading>Alabama</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Consumer Credit License #21815.
      </Typography>

      <StateHeading>Arizona</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Banker License #0904844.
      </Typography>

      <StateHeading>Arkansas</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Combination Mortgage Banker‑Broker‑Servicer License #11173.
      </Typography>

      <StateHeading>California</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Licensed by the Department of Financial Protection and Innovation (DFPI) under the California Residential
        Mortgage Lending Act. DFPI RMLA License #4130289.{' '}
        <Link component={RouterLink} to={PATHS.ccpp} underline="hover">
          View our CCPA policy
        </Link>
        .
      </Typography>

      <StateHeading>Colorado</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Company Registration. NMLS #3001.
      </Typography>

      <StateHeading>Delaware</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Licensed Lender #33825.
      </Typography>

      <StateHeading>District of Columbia</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Dual Mortgage License #MLB3001. NMLS #3001.
      </Typography>

      <StateHeading>Florida</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Lender/Servicer License #897.
      </Typography>

      <StateHeading>Georgia</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Residential Mortgage Licensee. NMLS #3001.
      </Typography>

      <StateHeading>Idaho</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Broker/Lender License #MBL‑802.
      </Typography>

      <StateHeading>Iowa</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Banker License #2004‑0179.
      </Typography>

      <StateHeading>Kansas</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Licensed Mortgage Company #MC0025318.
      </Typography>

      <StateHeading>Kentucky</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Company License #MC751526.
      </Typography>

      <StateHeading>Maine</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Supervised Lender License. NMLS #3001.
      </Typography>

      <StateHeading>Maryland</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Lender License #3001.
      </Typography>

      <StateHeading>Michigan</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        First Mortgage Broker/Lender/Servicer License #FR0026477. Second Mortgage Broker/Lender/Servicer
        Registrant #SR0019918.
      </Typography>

      <StateHeading>Mississippi</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Lender License. NMLS #3001.
      </Typography>

      <StateHeading>Nebraska</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Lender License #1964.
      </Typography>

      <StateHeading>Nevada</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Company License #1198344 (NMA‑1198344). Branch NMLS #151941 — 9805 Double R Blvd., Suite 300,
        Office 3058, Reno, NV 89521. Supplemental Servicer License #1198345 (NSMC‑1198345).
      </Typography>

      <StateHeading>New Hampshire</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Banker License #3001MB.
      </Typography>

      <StateHeading>New Mexico</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Loan Company License. NMLS #3001.
      </Typography>

      <StateHeading>North Carolina</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Lender License #L‑209071. NMLS #2767217.
      </Typography>

      <StateHeading>North Dakota</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Residential Mortgage Lender License #ML104947.
      </Typography>

      <StateHeading>Ohio</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Residential Mortgage Lending Act Certificate of Registration #RM850096.
      </Typography>

      <StateHeading>Oregon</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Lending License #ML‑4807. Branch: 5600 S. Quebec Street, Suite 100‑D, Greenwood Village, CO 80111.
      </Typography>

      <StateHeading>Pennsylvania</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Servicer License #67753. NMLS #2767217.
      </Typography>

      <StateHeading>South Carolina</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        BFI Mortgage Lender/Servicer License #MLS‑3001. NMLS #2767217.
      </Typography>

      <StateHeading>South Dakota</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage Lender License #3001ML.
      </Typography>

      <StateHeading>Tennessee</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Mortgage License #3001.
      </Typography>

      <StateHeading>Texas</StateHeading>
      <Typography variant="body1" sx={{ mb: 1 }}>
        Mortgage Banker Registration. NMLS #3001.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Figure: 7 TAC §81.200(c) — Consumers wishing to file a complaint against a mortgage banker or a licensed
        mortgage banker residential mortgage loan originator should complete and send a complaint form to the Texas
        Department of Savings and Mortgage Lending, 2601 North Lamar, Suite 201, Austin, Texas 78705. Complaint
        forms and instructions may be obtained from the department&rsquo;s website at{' '}
        <Link href="https://www.sml.texas.gov" target="_blank" rel="noopener" underline="hover">
          www.sml.texas.gov
        </Link>
        . A toll-free consumer hotline is available at 1-877-276-5550. The department maintains a recovery fund to
        make payments of certain actual out of pocket damages sustained by borrowers caused by acts of licensed
        mortgage banker residential mortgage loan originators. A written application for reimbursement from the
        recovery fund must be filed with and investigated by the department prior to the payment of a claim. For
        more information about the recovery fund, please consult the department&rsquo;s website at{' '}
        <Link href="https://www.sml.texas.gov" target="_blank" rel="noopener" underline="hover">
          www.sml.texas.gov
        </Link>
        .
      </Typography>

      <StateHeading>Utah</StateHeading>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Residential First Mortgage Notification #UDFI‑RFMN2015. Mortgage Entity License #6168217.
      </Typography>

      <StateHeading>Washington</StateHeading>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Consumer Loan Company License #CL‑3001.
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        Cherry Creek Mortgage, LLC Nationwide Mortgage Licensing System Number 3001. Toll Free: 800-295-4439.
      </Typography>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>
        Cherry Creek Mortgage, LLC Affiliated Businesses
      </Typography>
      <List disablePadding sx={{ mb: 2 }}>
        {[
          { name: 'Jet HomeLoans, LLC', href: 'https://jethl.com/' },
          { name: 'Dream Finders Homes, LLC', href: 'https://dreamfindershomes.com/' },
          { name: 'Beazer Homes, USA, Inc.', href: 'https://www.beazer.com/' },
          { name: 'DF Title, LLC d/b/a Golden Dog Title', href: 'https://goldendogtitle.com/' },
          { name: 'Alliant National Title', href: 'https://alliantnational.com/' },
          { name: 'Pine Ridge Insurance', href: 'https://www.pineridgeins.com/' },
        ].map(({ name, href }) => (
          <ListItem key={name} disableGutters sx={{ py: 0.25 }}>
            <ListItemText
              primary={
                <Link href={href} target="_blank" rel="noopener" underline="hover">
                  {name}
                </Link>
              }
              primaryTypographyProps={{ variant: 'body1' }}
            />
          </ListItem>
        ))}
      </List>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>Pre-Approval Disclosure</Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        *&ldquo;Pre-Approval&rdquo; means an automated underwriting system approval (conditional approval) based
        upon credit information supplied by the applicant and subject to Cherry Creek Mortgage, LLC&rsquo;s review
        of loan documents. Not all applicants will be approved.
      </Typography>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>
        Information regarding risks of reverse mortgages:
      </Typography>
      <List disablePadding sx={{ mb: 2 }}>
        {[
          'A reverse mortgage is a loan that must be repaid',
          'Circumstances under which payments or access to a line of credit may end or a consumer would be required to repay a reverse mortgage during the consumer\'s life (e.g., the borrower sells the home)',
          'Foreclosure may occur if the consumer (1) lives somewhere other than the home longer than allowed by the loan agreement; or (2) does not pay property taxes or insurance premiums',
          'Consumers must make payments for taxes and insurance during the term of the reverse mortgage',
          'Reverse mortgage costs may vary and less expensive options may be available',
          'A reverse mortgage may affect eligibility for some government programs. Specifically, SSI and Medicaid may be affected.',
          'In order to retain the home when the reverse mortgage becomes due that (1) the consumer or the consumer\'s heirs or estate must pay the entire loan balance and (2) the balance may be greater than the value of the consumer\'s home.',
        ].map((item) => (
          <ListItem key={item} disableGutters sx={{ py: 0.25 }}>
            <ListItemText primary={item} primaryTypographyProps={{ variant: 'body1' }} />
          </ListItem>
        ))}
      </List>
    </LegalPage>
  );
}
